//
//  env.ts
//
//  isana.net,inc. Proprietary and Confidential
//

// fitbit関連の環境変数
// NOTE: Fitbit Web API 直接連携（Home/Auth）は削除済み。FITBIT_CLIENT_ID は
// 連携済みユーザ一覧の列表示トグルとしてのみ利用。
export const FITBIT_CLIENT_ID = process.env.REACT_APP_CLIENT_ID ?? "";

// fitinsight関連の環境変数
export const API_URL = process.env.REACT_APP_API_URL;
export const API_KEY = process.env.REACT_APP_API_KEY; // x-api-key

// 連携ページで利用する環境変数
export const PUBLIC_URL = process.env.PUBLIC_URL;
// 固定値
export const PAGE_TITLE = process.env.REACT_APP_PAGE_TITLE;
export const OBJECT_TEXT = process.env.REACT_APP_OBJECT_TEXT;
export const OFFICIAL_WEB_SITE_URL =
  process.env.REACT_APP_OFFICIAL_WEB_SITE_URL;
export const OFFICIAL_WEB_SITE_NAME =
  process.env.REACT_APP_OFFICIAL_WEB_SITE_NAME;
// fitinsightuniqueid
export const FITINSIGHT_UNIQUE_ID_USED =
  process.env.REACT_APP_FITINSIGHT_UNIQUE_ID_USED === "true";
export const FITINSIGHT_UNIQUE_ID_MESSAGE =
  process.env.REACT_APP_FITINSIGHT_UNIQUE_ID_MESSAGE;
// group
export const GROUP_USED = process.env.REACT_APP_GROUP_USED === "true";
export const GROUP_MESSAGE = process.env.REACT_APP_GROUP_MESSAGE;
export const GROUP_SELECT = process.env.REACT_APP_GROUP_SELECT;

// 利用規約ページで利用する環境変数
export const TERMS_PAGE_TEXT = process.env.REACT_APP_TERMS_PAGE_TEXT ?? "";

// firebase関連の環境変数
export const FIREBASE_API_KEY = process.env.REACT_APP_FIREBASE_API_KEY;
export const FIREBASE_AUTH_DOMAIN = process.env.REACT_APP_FIREBASE_AUTH_DOMAIN;
export const FIREBASE_PROJECT_ID = process.env.REACT_APP_FIREBASE_PROJECT_ID;
export const FIREBASE_STORE_BUCKET =
  process.env.REACT_APP_FIREBASE_STORE_BUCKET;
export const FIREBASE_MESSAGING_SENDER_ID =
  process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID;
export const FIREBASE_APP_ID = process.env.REACT_APP_FIREBASE_APP_ID;

// mock
export const MOCK_USED = process.env.REACT_APP_MOCK_USED === "true";

// blood pressure
export const BLOOD_PRESSURE_USED =
  process.env.REACT_APP_BLOOD_PRESSURE_USED === "true";

// csv export
export const CSV_EXPORT_USED = process.env.REACT_APP_CSV_EXPORT_USED === "true";

// GHA csv export
// API側と同様に未設定時は無効。"true" を設定したテナントのみ有効化される
export const GOOGLE_HEALTH_CSV_EXPORT_ENABLED =
  process.env.REACT_APP_GOOGLE_HEALTH_CSV_EXPORT_ENABLED === "true";

// Intraday
export const isIntradayNeeded = process.env.REACT_APP_INTRADAY_NEED === "true";

// companyId使用するかどうか
export const isCompanyIdUsed = process.env.REACT_APP_COMPANY_ID_USED === "true";

// お問い合わせバックログのURL
export const CONTACT_URL = process.env.REACT_APP_CONTACT_URL ?? "";

// Intradayのデータ取得間隔
export const IntradayIntervalMinutes =
  process.env.REACT_APP_INTRADAY_INTERVAL_MINUTES;

// 認証種別
export enum AuthType {
  Microsoft = "Microsoft",
  Google = "Google",
}
// 認証関連の環境変数検証ロジック
export const validateAuthEnv = ({
  REACT_APP_AUTH_TYPE,
  REACT_APP_MICROSOFT_TENANT_ID,
}: {
  REACT_APP_AUTH_TYPE?: string;
  REACT_APP_MICROSOFT_TENANT_ID?: string;
}) => {
  const rawAuthType = REACT_APP_AUTH_TYPE;
  if (
    !rawAuthType ||
    !Object.values(AuthType).includes(rawAuthType as AuthType)
  ) {
    throw new Error(
      "AUTH_TYPE環境変数が不正です。Google/Microsoftのみ指定可能です。"
    );
  }
  const authType = rawAuthType as AuthType;

  const microsoftTenantId = REACT_APP_MICROSOFT_TENANT_ID ?? "";
  if (authType === AuthType.Microsoft && !microsoftTenantId) {
    throw new Error(
      "MICROSOFT_TENANT_IDが未設定です。Microsoft認証には必須です。"
    );
  }
  return { AUTH_TYPE: authType, MICROSOFT_TENANT_ID: microsoftTenantId };
};

const { AUTH_TYPE, MICROSOFT_TENANT_ID } = validateAuthEnv({
  REACT_APP_AUTH_TYPE: process.env.REACT_APP_AUTH_TYPE,
  REACT_APP_MICROSOFT_TENANT_ID: process.env.REACT_APP_MICROSOFT_TENANT_ID,
});
export { AUTH_TYPE, MICROSOFT_TENANT_ID };
